<template>
  <nav class="main-menu" :class="isMainMenuActiveMobile ? 'active' : ''">
    <div class="main-menu__header">
      <div @click="toggleMainMenu">
      <router-link to="/" class="logo-sm main-menu__logo" >
        <img src="/img/svg/logo_sm.svg" alt="Интекс">
      </router-link>
    </div>
      <transition name="fade">
        <div class="main-menu__back-button" v-show="!isMainMenuActive" @click="toggleMainMenu">
          <svg class="arrow-prev-icon" viewBox="0 0 17 16" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                d="M16.023 7.96802L1.99946 8.04702M1.99946 8.04702L7.22547 2.97317M1.99946 8.04702L7.3552 13.5634"
                stroke-width="1.5"/>
          </svg>
        </div>
      </transition>
    </div>

    <!-- заголовок раздела -->
    <div class="main-menu-title-wrap" v-show="!isMainMenuActive">
      <div v-if="currentActiveMenu.is_root" class="main-menu__title">
        <div class="section-icon"
             :style="{background: currentActiveMenu.icon.colorSecond, background: `linear-gradient(90deg, ${currentActiveMenu.icon.colorFirst} -35.71%, ${currentActiveMenu.icon.colorSecond} 142.86%)`}">
          <div class="section-icon__img">
            <img :src="currentActiveMenu.icon.img" :alt="currentActiveMenu.title">
          </div>
        </div>
        {{ currentActiveMenu.title }}
      </div>
      <div v-else class="main-menu__title-prev"
           @click="backToParentMenu"
      >
        <div class="main-menu__title-prev__inner">
          <div>
            <svg class="arrow-prev-icon" viewBox="0 0 17 16" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path
                  d="M16.023 7.96802L1.99946 8.04702M1.99946 8.04702L7.22547 2.97317M1.99946 8.04702L7.3552 13.5634"
                  stroke-width="1.5"/>
            </svg>
          </div>
          <p class="main-menu__title-prev__text">Назад</p>
        </div>
      </div>
    </div>
    <!-- /заголовок раздела -->

    <div class="main-menu__list">
      <!-- список основного меню -->
      <AppMenuListMain v-show="isMainMenuActive"/>
      <!-- /список основного меню -->

      <!-- список разделов с заголовком -->
      <AppMenuListSections v-show="!isMainMenuActive" />
      <!-- /список разделов с заголовком -->
    </div>

    <!--скрыто за ненадобностью-->
    <div class="main-menu__footer-wrap" v-show="/*mediaBreakpoint === 'desktop'*/false">
      <AppMenuFooter @log-out="logOut"/>
    </div>
  </nav>
</template>

<script>
import AppMenuListMain from './AppMenuListMain.vue'
import AppMenuListSections from './AppMenuListSections.vue'
import AppMenuFooter from './AppMenuFooter.vue'

export default {
  name: 'AppMenu',
  components: {
    AppMenuListMain,
    AppMenuListSections,
    AppMenuFooter
  },
  computed: {
    currentActiveMenu () {
      return this.$store.getters.activeMenu
    },
    isMainMenuActive () {
      return this.$store.getters.mainMenu.is_active
    },
    isMainMenuActiveMobile () {
      return this.$store.getters.mainMenu.is_active_mobile
    },
    mediaBreakpoint () {
      return this.$store.getters.getMediaBreakpoint
    },
    currentRoutePath () {
      return this.$route.path
    }
  },
  methods: {
    toggleMainMenu () {
      this.$store.dispatch('toggleMainMenu')
    },
    backToParentMenu () {
      const parentMenu = this.currentActiveMenu.parentMenu
      this.$store.dispatch('switchMenu', { menu: parentMenu, isSubmenu: true })
    },
    logOut () {
      this.$emit('log-out')
    }
  },
  mounted () {}
}

</script>

<style lang="scss" scoped>
@import '../../assets/css/system/_vars';
@import '../../assets/css/system/_mixins';

.main-menu {
  position: fixed;
  z-index: 99999;
  top: 0;
  right: auto;
  left: 0;
  bottom: 0;
  display: flex;
  flex-direction: column;
  width: 260px;
  background-color: $color_second;
  color: $font_color_alt;
  font-size: 14px;
  transition: .3s;

  @media screen and (max-width: $tablet_start) {
    top: $header_height_mobile;
    left: -260px;

    &.active {
      transform: translateX(260px);
    }
  }

  &__header {
    padding: 20px 15px 20px 20px;
    background-image: url('/img/svg/background_01.svg');
    background-repeat: no-repeat;
    background-size: cover;
    display: flex;
    justify-content: space-between;
    align-items: center;
    height: $header_height;
    box-shadow: inset 0 -3px 0 0 $color_second-dark;
  }

  &__back-button {
    cursor: pointer;
    user-focus: none;
    transition: .3s;

    &:hover {
      opacity: .6;
    }

    .arrow-prev-icon {
      width: 21px;
      height: 20px;
    }
  }

  &__title {
    display: flex;
    align-items: center;
    background-color: $color_second-dark;
    padding: 10px 15px 10px 20px;
    min-height: 40px;

    .section-icon {
      margin-right: 16px;
    }
  }

  &__title-prev {
    background-color: $color_second-dark;
    padding: 10px 15px 10px 20px;
    min-height: 40px;
    cursor: pointer;
    user-select: none;

    &__text {
      margin-left: 20px;
    }

    &__inner {
      display: flex;
      align-items: center;
      transition: .3s;
    }

    &:hover {
      .main-menu__title-prev__inner {
        opacity: .6;
      }
    }

    &:active {
      .main-menu__title-prev__inner {
        color: $color_second-light;
      }
    }
  }

  &__list {
    flex: 1;
    overflow: auto;
    margin: 10px 0 10px 0;

    &::-webkit-scrollbar {
      width: 12px;
    }

    &::-webkit-scrollbar-track {
      /* background-color: transparentize($color_main, .6); */
      background: linear-gradient(90deg, transparentize($color_main, .6) 0%, transparentize($color_main, .6) 50%, rgba(0, 0, 0, 0) 50%, rgba(0, 0, 0, 0) 100%);
    }

    &::-webkit-scrollbar-thumb {
      /* background-color: transparentize($color_main, .4); */
      background: linear-gradient(90deg, transparentize($color_main, .4) 0%, transparentize($color_main, .4) 50%, rgba(0, 0, 0, 0) 50%, rgba(0, 0, 0, 0) 100%);
    }
  }
}
</style>
